import { render, staticRenderFns } from "./CookiesPolicyView.vue?vue&type=template&id=4a760c85"
import script from "./CookiesPolicyView.vue?vue&type=script&lang=js"
export * from "./CookiesPolicyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports